export const config = {
  id: 'content-designer',
  icon: 'PenTool',
  color: 'emerald',
  title: 'Content Designer',
  description: 'UX writing, content strategy, and microcopy design',
  department: 'Design',
  experienceLevels: ['junior', 'mid', 'senior'],
  operatingSystems: ['macos', 'windows', 'linux'],
  estimatedOnboardingDays: {
    junior: 3,
    mid: 2,
    senior: 2
  }
};
